import {
  MdDashboard,
  MdBuild,
  MdPeople,
  MdOutlineMessage,
  MdCategory,
  MdAutorenew,
  MdTag,
  MdOutlineInsertChart,
  MdMoreHoriz,
} from "react-icons/md";

export const BRAND = {
  name: "Abogados",
  panelLabel: "Panel admin",
  logoUrl: "/obediente.png",
  logoAlt: "Abogados",
};

export const LOGO_URL = BRAND.logoUrl;

export const NAV_GROUP_LABELS = {
  general: "General",
  operations: "Operaciones",
  admin: "Administración",
};

/** Todas las rutas del panel (sidebar escritorio + hoja "Más" en móvil) */
export const NAV_ITEMS = [
  {
    label: "Dashboard",
    shortLabel: "Inicio",
    description: "Resumen y métricas",
    icon: MdDashboard,
    route: "/Home",
    group: "general",
  },
  {
    label: "Abogados",
    shortLabel: "Abogados",
    description: "Gestión de abogados",
    icon: MdBuild,
    route: "/Control-Tecnico",
    group: "operations",
  },
  {
    label: "Clientes",
    shortLabel: "Clientes",
    description: "Clientes internos",
    icon: MdPeople,
    route: "/Control-cliente",
    group: "operations",
  },
  // {
  //   label: "Publicidades",
  //   shortLabel: "Avisos",
  //   description: "Avisos y campañas",
  //   icon: MdOutlineMessage,
  //   route: "/Publicidad",
  //   group: "operations",
  // },
  {
    label: "Suscripciones",
    shortLabel: "Planes",
    description: "Planes y membresías",
    icon: MdAutorenew,
    route: "/Suscripciones",
    group: "operations",
  },
  {
    label: "Usuarios & Roles",
    shortLabel: "Usuarios",
    description: "Accesos y permisos",
    icon: MdCategory,
    route: "/Categorias",
    group: "admin",
  },
  {
    label: "Categorías",
    shortLabel: "Categorías",
    description: "Catálogo de categorías",
    icon: MdTag,
    route: "/Categoria",
    group: "admin",
  },
  {
    label: "Actividad",
    shortLabel: "Actividad",
    description: "Registro de actividad",
    icon: MdPeople,
    route: "/Actividades",
    group: "admin",
  },
  {
    label: "Reportes",
    shortLabel: "Reportes",
    description: "Informes y exportación",
    icon: MdOutlineInsertChart,
    route: "/Reportes",
    group: "admin",
  },
];

export const NAV_SECTIONS = Object.keys(NAV_GROUP_LABELS).map((groupId) => ({
  id: groupId,
  title: NAV_GROUP_LABELS[groupId],
  items: NAV_ITEMS.filter((item) => item.group === groupId),
}));

/** Rutas visibles en la tab bar inferior (móvil / tablet) */
export const TAB_BAR_ROUTES = ["/Home", "/Control-Tecnico", "/Control-cliente", "/Publicidad"];

export const TAB_BAR_ITEMS = [
  NAV_ITEMS.find((i) => i.route === "/Home"),
  NAV_ITEMS.find((i) => i.route === "/Control-Tecnico"),
  NAV_ITEMS.find((i) => i.route === "/Control-cliente"),
  NAV_ITEMS.find((i) => i.route === "/Publicidad"),
  { label: "Más", shortLabel: "Más", icon: MdMoreHoriz, route: null, isMore: true },
];

export const MORE_MENU_ITEMS = NAV_ITEMS.filter((item) => !TAB_BAR_ROUTES.includes(item.route));

export const isRouteActive = (pathname, route) => pathname === route;

export const isMoreRouteActive = (pathname) =>
  MORE_MENU_ITEMS.some((item) => item.route === pathname);
